import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavbarTop from 'components/navbar/top/NavbarTop';
import AppContext from 'contexts/Context';
import classNames from 'classnames';
import useAuth from 'hooks/useAuth';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/th';

const MainLayout = () => {
  const { user } = useAuth();
  const { i18n } = useTranslation();

  const { hash, pathname } = useLocation();
  const {
    config: { isFluid }
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);

    if (user.languageCode !== 'th') {
      i18n.changeLanguage('en');
      moment.locale('en');
    } else {
      i18n.changeLanguage('th');
      moment.locale('th');
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      <div className={classNames('content')}>
        <NavbarTop isPublic={false} />
        {/*------ Main Routes ------*/}
        <Outlet />
        <div style={{ position: 'absolute', bottom: '0', right: '0' }}>
          v1.0.8
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
